import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';

import { PatientEncounterReviewApi } from '../../../../../../../api';
import ModalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { ReviewContext } from '../../ReviewContext';
import ElementHistoryLogCheckModal from '../HistoryLogCheckModal/ElementHistoryLogCheckModal';
import ItemGroupElementHeader from '../ItemGroupElementHeader/ItemGroupElementHeader';

import LogCheckItemGroupContent from './LogCheckItemGroupContent/LogCheckItemGroupContent';
import LogItemGroupContent from './LogItemGroupContent/LogItemGroupContent';

export default function LogItemGroupElement({
  logSnapshotState,
  logCheckSnapshotState,
  isLogPresent,
  isLogCheckPresent,
  logCheckItem,
  item
}) {
  const { isHistoricalData } = useContext(ReviewContext);
  const itemGroupTemplateId = logSnapshotState?.logFormRef.itemGroupTemplateId;
  const logName = logSnapshotState?.logFormRef?.name;
  const showLogCheckHistoryButton =
    logCheckSnapshotState?.encounterLogCheckSnapshotKey?.recordVersion >= 1 && !isHistoricalData;

  return (
    <div className="eds-review-item-group-element" id={itemGroupTemplateId}>
      {logSnapshotState && (
        <ItemGroupElementHeader
          itemGroupName={logName}
          itemGroupType="Logs"
          showHistoryButton={showLogCheckHistoryButton}
          getAnswersHistory={getLogCheckAnswersHistory}
        />
      )}
      {isLogCheckPresent && <LogCheckItemGroupContent logCheckSnapshotState={logCheckSnapshotState} />}
      {isLogPresent && <LogItemGroupContent logSnapshotState={logSnapshotState} item={item} />}
    </div>
  );

  function getLogCheckAnswersHistory() {
    const onLoadData = () =>
      PatientEncounterReviewApi.getLogCheckAnswerHistory(
        logCheckSnapshotState?.encounterLogCheckSnapshotKey?.encounterLogCheckKey?.ssuPatientId,
        logCheckSnapshotState?.encounterLogCheckSnapshotKey?.encounterLogCheckKey?.sitePatientEncounterId,
        logCheckItem?.patientItemGroupId
      );

    ModalBoxes.open({
      component: <ElementHistoryLogCheckModal onLoadData={onLoadData} />,
      title: logCheckItem?.patientItemGroupName
    });
  }
}

LogItemGroupElement.propTypes = {
  logSnapshotState: PropTypes.object,
  logCheckSnapshotState: PropTypes.object,
  isLogPresent: PropTypes.bool,
  isLogCheckPresent: PropTypes.bool,
  logCheckItem: PropTypes.object
};
